export default "/ui/images/greenmarker.svg";